<script>
import { FormWizard, TabContent } from 'vue-form-wizard'

import appConfig from '@src/app.config'
import Layout from '@layouts/newdefaultform'
import PageHeader from '@components/page-header'
import { giftlistApi } from '@router/apiFiles/giftlistApi'

	
import Step1 from './step1'
import Step2 from './step2'
import Step3 from './step3'
import Step4 from './step4'

export default {
	page: {
		title: 'Criar lista',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, FormWizard, TabContent, Step1, Step2, Step3, Step4 },
	data() {
		return {
			title: 'Criar lista',
			items: [
				{
					text: 'LaVille',
					href: '/',
				},
				{
					text: 'Listas',
					href: '/',
				},
				{
					text: 'Criar',
					active: true,
				},
			],
			creating: true,
			isBusy: false,
			editModel: {},
			finalModel: {},
			accept: '',
		}
	},
    mounted() {
        this.fetchData()
    },	
	methods: {
		async fetchData() {
			var self = this;
			var urlText = self.$route.params.urlText;
		},
		validateStep(name) {
			var refToValidate = this.$refs[name]
			return refToValidate.validate()
		},
		mergePartialModels(model, isValid) {
			if (isValid) {
				// merging each step model into the final model
				this.finalModel = Object.assign({}, this.finalModel, model)
			}
		},
		onComplete() {
			this.isBusy = true;
			console.log('completed')
			console.log(this.finalModel)
			var self = this;
			giftlistApi
				.createGiftlist({
        			contact1_firstName: self.finalModel.firstName1,
        			contact1_lastName: self.finalModel.lastName1,
        			contact1_email: self.finalModel.email1,
        			contact1_phone: self.finalModel.phone1,
        			contact1_document: self.finalModel.document1,
        			contact2_firstName: self.finalModel.firstName2,
        			contact2_lastName: self.finalModel.lastName2,
        			contact2_email: self.finalModel.email2,
        			contact2_phone: self.finalModel.phone2,
        			contact2_document: self.finalModel.document2,
        			eventType: self.finalModel.listType,
        			eventDate: self.finalModel.date,
        			eventPlace: self.finalModel.place,
        			eventCity: self.finalModel.city,
        			eventState: self.finalModel.state,
        			address_street: self.finalModel.address_street,
        			address_city: self.finalModel.address_city,
        			address_state: self.finalModel.address_state,
        			address_country: 'Brasil',
        			address_zipcode: self.finalModel.address_zipcode,
        			address_neighborhood: self.finalModel.address_neighborhood,
					address_number: self.finalModel.address_number,
					address_complement: self.finalModel.address_complement,
					url: self.finalModel.url
				}).then(function(data) {
					self.$router.push({ path: '/minhaslistas' })
				});
		}
	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">			
			<div class="col-md-10 offset-md-1">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body">
						<h4 class="header-title mt-0 mb-1">Informações da Lista</h4>
						<form-wizard color="#000" error-color="#ff5c75" nextButtonText="Próximo" backButtonText="Anterior" finishButtonText="Criar Lista" @on-complete="onComplete">

							<tab-content
								title="Evento"
								:before-change="() => validateStep('step1')"
							>
								<Step1 ref="step1" @on-validate="mergePartialModels" />
							</tab-content>

							<tab-content
								title="Contato"
								:before-change="() => validateStep('step2')"
							>
								<Step2 ref="step2" @on-validate="mergePartialModels" />
							</tab-content>

							<tab-content
								title="Resgate"
								:before-change="() => validateStep('step3')"
							>
								<Step3 ref="step3" @on-validate="mergePartialModels" />
							</tab-content>

							<tab-content
								title="Regulamento"
								:before-change="() => validateStep('step4')"
							>
								<Step4 ref="step4" @on-validate="mergePartialModels" />
							</tab-content>
							
							
							<tab-content title="Concluir">
								<div class="row">
									<div class="col-12">
																		
										<div class="text-center">										
											<h2 class="mt-0">
												<i class="mdi mdi-check-all"></i>
											</h2>
											<h3 class="mt-0">Obrigado por criar sua lista na LaVille!</h3>

											<p class="w-75 mb-2 mx-auto">
												Clicando em `Criar lista` você poderá desfrutar de todos os benefícios da lista LaVille e encantar seus convidados com as opções de presentes.
											</p>
											
											<br />
										</div>
									</div>
								</div>
								<div class="waitLoad" v-show="isBusy">
									<div class="text-center text-danger my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>			
								</div>								
							</tab-content>
							
						</form-wizard>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<style lang="scss">
	.waitLoad {
		position: absolute;
		top: 0;
		left:0;
		width:100%;
		height: 100%;
		background: rgb(255,255,255,0.8);
		padding-top: 22%;
	}
</style>